import ChipButton from 'components/ChipButton'
import Header from 'components/Header'
import Pagination from 'components/Pagination'
import PrimaryButton from 'components/PrimaryButton'
import ResultsList from 'components/ResultList'
import SortWrapper from 'components/SortWrapper'
import { FetchContext } from 'contexts/FetchContext'
import { parseParams } from 'helpers/querystring'
import useScrollPosition from 'hooks/useScrollPosition'
import useSearch from 'hooks/useSearch'
import useUrlParams from 'hooks/useUrlParams'
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import SearchBox from 'widgets/SearchBox'
import Facets from 'widgets/SearchFilters/Facets'
import ResultView from 'widgets/SearchResult'
import FacetsTags from 'widgets/SearchResult/FacetsTags'
import ResultTemplateSwitch from 'widgets/SearchResult/ResultTemplateSwitch'
import ResultsContainer from 'widgets/SearchResult/ResultsContainer'
import ResultsHeader from 'widgets/SearchResult/ResultsHeader'
import TotalHits from 'widgets/SearchResult/TotalHits'
import TotalHitsZero from 'widgets/SearchResult/TotalHitsZero'
import SearchTabs from 'widgets/SearchTabs'

function General() {
  const { t } = useTranslation()
  const { urlParams, updateUrlParams } = useUrlParams()
  const defaultHits = 25
  const { resultList, setIsAppendResults } = useContext(FetchContext)
  if (!urlParams.hits) {
    updateUrlParams({ hits: defaultHits })
  }

  const {
    quicklinks = [],
    facets = [],
    stats = { totalHits: 0 },
    sortOptions = [],
    inputText,
  } = useSearch()
  const quicklinksWithType = quicklinks.map((item) => ({
    ...item,
    type: '__quicklink__',
  }))
  const quicklinksAndDocuments = quicklinksWithType.concat(resultList)

  useScrollPosition(resultList)

  const handleSort = (query) => {
    const { sort } = parseParams(query) // sort parameters value "relevance" is currently only available through the query field
    updateUrlParams({ sort })
  }

  const handleMore = () => {
    setIsAppendResults(true)
    const { hits = defaultHits } = urlParams
    updateUrlParams({ hits: parseInt(hits) + 10 })
  }

  return (
    <div className="row expanded">
      <Header className={!facets.length && 'u-pb-150 u-pb-200-large-up'}>
        <SearchBox />
        <SearchTabs />
      </Header>
      <div className="wrapper">
        <Facets facets={facets} />
        <ResultView>
          <ResultsContainer>
            {/* Hits and Sorting */}
            {!!quicklinksAndDocuments.length && (
              <ResultsHeader modifierClasses="u-align-baseline">
                <div className="columns small-12 medium-8 u-pl-0 u-mb-100 u-mb-0-medium-up">
                  <TotalHits
                    showingNumberOfHits={quicklinksAndDocuments.length}
                    totalNumberOfHits={stats.totalHits + quicklinks.length}
                  />
                </div>
                <FacetsTags facets={facets} />
                <div className="columns small-12 medium-4 u-text-right-medium-up u-pl-0 u-pr-0 u-mb-100 u-mb-0-medium-up">
                  <SortWrapper>
                    {!!sortOptions &&
                      sortOptions.map(({ displayName, selected, query }) => (
                        <ChipButton
                          ariaLabel={`${t('Sort by')} ${displayName}`}
                          label={displayName}
                          modifierClasses={['u-ml-50']}
                          selected={selected}
                          onClick={() => handleSort(query)}
                          key={query}
                        />
                      ))}
                  </SortWrapper>
                </div>
              </ResultsHeader>
            )}
            {/* Result list */}
            {!!quicklinksAndDocuments.length && (
              <ResultsList
                documents={quicklinksAndDocuments}
                render={(doc) => <ResultTemplateSwitch {...doc} />}
              />
            )}

            {/* No Results */}
            {!quicklinksAndDocuments.length && inputText && <TotalHitsZero />}
          </ResultsContainer>

          {/* Pagination */}
          <Pagination>
            {resultList.length < stats.totalHits && (
              <PrimaryButton
                label={t('Show more')}
                modifierClasses={[
                  'u-mt-100 link link--highlighted u-text-center u-width-full',
                ]}
                onClick={() => handleMore()}
                size="tiny"
                fullWidth="true"
              />
            )}
          </Pagination>
        </ResultView>
      </div>
    </div>
  )
}

export default General
